import React from 'react';
import './AppOverlay.scss';

export const AppOverlay: React.FC = () => <div id="app-overlay" />;
